import { observable, action } from 'mobx';
import { Score } from 'api';

class ScoreStore {
  @observable score;

  @observable fetchState;

  @observable updateScoreState;

  @action.bound
  async getScore(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Score.getScore(anketId);
      this.score = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }

  @action.bound
  async forceUpdateScore() {
    this.updateScoreState = 'pending';

    try {
      await Score.forceUpdateScore(this.anketId);
      this.updateScoreState = 'fulfilled';
    } catch (e) {
      this.updateScoreState = 'rejected';
    }
  }
}

const scoreStore = new ScoreStore();

export default scoreStore;
